import Payment from './Payment.vue'

export default Payment
